import React, { useEffect, useRef, useState } from "react";
import ExtensionCard from "app/popleads/components/ui-kit/ExtensionCard";
import { useExtensionContext } from "../ExtensionContext";
import styled from "styled-components";
import ExtensionNotesFooter from "./ExtensionNotesFooter";
import useGetProfileNotes from "app/popleads/hooks/useGetProfileNotes";
import { StyledCardContent } from "./common/styled";
import ExtensionNote from "./ExtensionNote";
import { ProfileLoadingOverlay } from "../ExtensionHome";
import { Spinner } from "react-bootstrap";

const StyledContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    flex: 1;
    overflow-y: auto;
    padding: 8px 12px;
    min-height: 0;
`;

const Flex = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    position: relative;
    overflow: hidden;
`;
//todo: profildeki notlar view more notes dedikten sonra düzeliyor
//todo: yeni bir not eklendiğinde üste ekleniyor. alta eklenecek şekilde ayarlanacak
const ExtensionNotesPage = () => {
    const containerRef = useRef(null);
    const prevScrollHeightRef = useRef(0);
    const [loadedNoteIds, setLoadedNoteIds] = useState(new Set());
    const [start, setStart] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [noteListArr, setNoteListArr] = useState([]);
    const { profile, noteList, setNoteList, isDeletingNote } = useExtensionContext();

    const ROWS_PER_PAGE = 100;
    const { profileNotes, loading: profileNotesLoading } = useGetProfileNotes(profile?.id, start, ROWS_PER_PAGE);

    const scrollToBottom = () => {
        const container = containerRef.current;
        if (container) {
            container.scrollTop = container.scrollHeight;
            prevScrollHeightRef.current = 0;
        }
    };

    useEffect(() => {
        if (profileNotes && !profileNotesLoading) {
            const newNotes = profileNotes.filter((note) => !loadedNoteIds.has(note.id));

            if (newNotes.length > 0) {
                setNoteList((prevNotes) => (start === 0 ? newNotes : [...prevNotes, ...newNotes]));
                const newNoteIds = new Set([...loadedNoteIds]);
                newNotes.forEach((note) => newNoteIds.add(note.id));
                setLoadedNoteIds(newNoteIds);
                if (start > 0) {
                    prevScrollHeightRef.current = containerRef.current.scrollHeight;
                } else {
                    prevScrollHeightRef.current = 0;
                }
            }
            setIsLoading(false);
        }
    }, [profileNotes, profileNotesLoading]);

    useEffect(() => {
        if (noteList && noteList?.length > 0) {
            const newNoteList = noteList?.map((note) => {
                return {
                    id: note.id,
                    icon: note.tip === "otomatik" && (
                        <StyledCardContent
                            variant={"warning"}
                            className="material-symbols-outlined"
                            style={{ fontSize: "22px", fontWeight: "300" }}
                        >
                            sync_problem
                        </StyledCardContent>
                    ),
                    content: <ExtensionNote variant="notes" note={note} />,
                };
            });

            setNoteListArr(newNoteList);
        }
    }, [noteList]);

    useEffect(() => {
        if (containerRef.current && noteListArr.length > 0) {
            containerRef.current.scrollTop = containerRef.current.scrollHeight - prevScrollHeightRef.current;
        }
    }, [noteListArr]);

    useEffect(() => {
        const handleScroll = () => {
            const container = containerRef.current;
            if (!container || isLoading || profileNotesLoading) return;

            const { scrollTop } = container;

            if (scrollTop < 50 && profileNotes && profileNotes.length === ROWS_PER_PAGE) {
                setIsLoading(true);
                setStart((prevStart) => prevStart + ROWS_PER_PAGE);
            }
        };

        const container = containerRef.current;
        if (container) {
            container.addEventListener("scroll", handleScroll);
        }

        return () => {
            if (container) {
                container.removeEventListener("scroll", handleScroll);
            }
        };
    }, [isLoading, profileNotesLoading, start, profileNotes]);

    return (
        <Flex>
            {isDeletingNote || (profileNotesLoading && start === 0) ? (
                <ProfileLoadingOverlay>
                    <Spinner animation="border" variant="primary" />
                </ProfileLoadingOverlay>
            ) : null}
            <StyledContainer ref={containerRef}>
                {profileNotesLoading && start > 0 && (
                    <div style={{ display: "flex", justifyContent: "center", padding: "10px" }}>
                        <Spinner animation="border" variant="primary" />
                    </div>
                )}
                <ExtensionCard variant={"notes-card"} cardItems={[...noteListArr].reverse()} haveViewMore={false} />
            </StyledContainer>
            <ExtensionNotesFooter scrollToBottom={scrollToBottom} />
        </Flex>
    );
};

export default ExtensionNotesPage;
